<template>
    <div style="height:50px;">
        <div style="position:fixed;width:100%;height:50px;line-height:50px;top:50;z-index:100;" class="title">
            <van-nav-bar :title="title" :left-text="leftText?'返回':undefined" @click-left="onClickLeft" class="title" :left-arrow="leftText" :right-text="rightText" @click-right="onClickRight"/>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        title:{
            type:String
        },
        leftText:{
            type:Boolean,
            default:true
        },
        rightText:{
            type:String,
            default:undefined
        }
    },
    data(){
        return{

        }
    },
    methods:{
        onClickLeft(){
            this.$router.go(-1)
        },
        onClickRight(){
            this.$emit('onClickRight')
        }
    }
}
</script>
<style scoped>
</style>